<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1 class="toc-head">Contents</h1>
<ol class="none" epub:type="list">
<li class="toc-chapter" id="chap-1"><a href="#/MyLuckyStar_chap1">One</a></li>
<li class="toc-chapter" id="chap-2"><a href="#/MyLuckyStar_chap2">Two</a></li>
<li class="toc-chapter" id="chap-3"><a href="#/MyLuckyStar_chap3">Three</a></li>
<li class="toc-chapter" id="chap-4"><a href="#/MyLuckyStar_chap4">Four</a></li>
<li class="toc-chapter" id="chap-5"><a href="#/MyLuckyStar_chap5">Five</a></li>
<li class="toc-chapter" id="chap-6"><a href="#/MyLuckyStar_chap6">Six</a></li>
<li class="toc-chapter" id="chap-7"><a href="#/MyLuckyStar_chap7">Aside: Who’s Who in the Cast</a></li>
<li class="toc-chapter" id="chap-8"><a href="#/MyLuckyStar_chap8">Seven</a></li>
<li class="toc-chapter" id="chap-9"><a href="#/MyLuckyStar_chap9">Eight</a></li>
<li class="toc-chapter" id="chap-10"><a href="#/MyLuckyStar_chap10">Nine</a></li>
<li class="toc-chapter" id="chap-11"><a href="#/MyLuckyStar_chap11">Ten</a></li>
<li class="toc-chapter" id="chap-12"><a href="#/MyLuckyStar_chap12">Eleven</a></li>
<li class="toc-chapter" id="chap-13"><a href="#/MyLuckyStar_chap13">Twelve</a></li>
<li class="toc-chapter" id="chap-14"><a href="#/MyLuckyStar_chap14">Thirteen</a></li>
<li class="toc-chapter" id="chap-15"><a href="#/MyLuckyStar_chap15">Fourteen</a></li>
<li class="toc-chapter" id="chap-16"><a href="#/MyLuckyStar_chap16">Fifteen</a></li>
<li class="toc-chapter" id="chap-17"><a href="#/MyLuckyStar_chap17">Sixteen</a></li>
<li class="toc-chapter" id="chap-18"><a href="#/MyLuckyStar_chap18">Seventeen</a></li>
<li class="toc-chapter" id="chap-19"><a href="#/MyLuckyStar_chap19">Eighteen</a></li>
<li class="toc-chapter" id="chap-20"><a href="#/MyLuckyStar_chap20">Nineteen</a></li>
<li class="toc-chapter" id="chap-21"><a href="#/MyLuckyStar_chap21">Twenty</a></li>
<li class="toc-chapter" id="chap-22"><a href="#/MyLuckyStar_chap22">Twenty-one</a></li>
<li class="toc-chapter" id="chap-23"><a href="#/MyLuckyStar_chap23">Twenty-two</a></li>
<li class="toc-chapter" id="chap-24"><a href="#/MyLuckyStar_chap24">Twenty-three</a></li>
<li class="toc-chapter" id="chap-25"><a href="#/MyLuckyStar_chap25">Twenty-four</a></li>
<li class="toc-chapter" id="chap-26"><a href="#/MyLuckyStar_chap26">Twenty-five</a></li>
<li class="toc-chapter" id="epil-1"><a href="#/MyLuckyStar_epil1">Epilogue</a></li>
<li class="toc-chapter" id="ackn-1"><a href="#/MyLuckyStar_ackn1">Author’s Notes and Acknowledgments</a></li>
<li class="toc-chapter" id="auth-1"><a href="#/MyLuckyStar_auth1">About the Author</a></li>
<li class="toc-chapter" id="appe-1"><a href="#/MyLuckyStar_appe1">Reading Group Guide</a></li>
<li class="toc-chapter" id="read-1"><a href="#/MyLuckyStar_read1">A conversation with Joe Keenan</a></li>
<li class="toc-chapter" id="back-1"><a href="#/MyLuckyStar_back1">Questions and topics for discussion</a></li>
</ol>
</nav>
<nav class="hidden-tag" epub:type="landmarks" hidden="hidden">
<h1>Navigation</h1>
<ol class="none" epub:type="list">
<li><a epub:type="bodymatter" href="#/MyLuckyStar_chap1">Begin Reading</a></li>
<li><a epub:type="toc" href="#/MyLuckyStar_toc">Table of Contents</a></li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MyLuckyStar_toc.vue?50a54f33